import { useCharacterModel } from "../three/useBaoModel";
import { Clip3D } from "../three/Clip3D";
import { ReadAloud } from "../brand/Experience";

export const NAYA_LINES = {
  village: "Bonjour Bao ! Le village a besoin de toi aujourd'hui. Prends ton temps, chaque geste compte, et je serai juste là.",
  savanna: "Bao, mon petit ! Les animaux de la savane t'attendent. Un pas après l'autre, sans te presser : c'est ainsi qu'on va loin.",
  river: "Doucement, Bao. La rivière est calme si l'on est calme. Respire, pose bien tes pieds, et traversons ensemble.",
  bridge: "Kofi a besoin de nous, Bao : le vieux pont a perdu des planches. Tiens-toi bien droit, transfère ton poids doucement, et le pont sera réparé.",
  forest: "Bienvenue dans ma forêt, Bao ! Je vais te guider : tends doucement les bras vers les fruits, et tourne ton buste comme les grandes lianes.",
};

/** Mama Naya (validated 3D model, waving) welcomes Bao at the start of every level; 2D illustration if 3D is unavailable. */
export const NayaGreeting = ({ level, onNext }) => {
  const model = useCharacterModel("naya", true), text = NAYA_LINES[level];
  return (
    <div className="rounded-3xl bg-white p-5 shadow-2xl" data-testid="naya-greeting" data-level={level}>
      <div className="relative -mx-2 -mt-2 h-[250px] overflow-hidden rounded-[1.6rem] bg-gradient-to-b from-[#EAF7F5] to-[#F6E9CF]">
        {model ? <Clip3D model={model} clip="wave" then="idle" testId="naya-3d" cam={[0, 0.85, 4.5]} /> : model === null && (
          <img decoding="async" src="/assets/characters/3d/naya_front.jpg" alt="Mama Naya" className="mx-auto h-full object-contain mix-blend-multiply" data-testid="naya-2d" />
        )}
        <span className="absolute left-3 top-3 rounded-full bg-[#0A2540] px-3 py-1 text-[10px] font-extrabold tracking-[0.2em] text-[#FFE29A]">MAMA NAYA</span>
      </div>
      <div className="relative mt-4 rounded-2xl bg-[#EAF7F5] p-4" data-testid="naya-speech">
        <span className="absolute -top-2 left-10 h-4 w-4 rotate-45 bg-[#EAF7F5]" />
        <p className="font-display text-lg font-bold leading-snug text-[#0A2540]">« {text} »</p>
      </div>
      <div className="mt-2"><ReadAloud testId="naya-read-aloud" text={text} /></div>
      <button data-testid="naya-greeting-continue" onClick={onNext}
        className="mt-4 h-16 w-full rounded-full bg-brand text-lg font-extrabold text-white shadow-lg shadow-[#17A2A2]/30 transition-transform active:scale-[.98]">Merci Mama Naya !</button>
    </div>
  );
};
